var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModuleStartLower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 495,
    height: 139,
    viewBox: "0 0 495 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_197_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.002 115.313L464.613 70.242L501.002 6.19389V5.53496L500.079 5.00781L463.031 70.3737L500.211 116.367L501.002 115.708V115.313Z",
    fill: "url(#paint0_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.999 250.658L398.162 193.199L500.999 116.631V116.368L500.208 115.445L396.58 192.672L395.789 193.331L500.34 251.844L500.999 250.658Z",
    fill: "url(#paint1_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501 115.312L464.084 69.582L385.77 98.7068L501 116.761V115.312ZM463.556 71.1635L499.022 115.18L390.78 98.3114L463.556 71.1635Z",
    fill: "url(#paint2_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.001 115.445L388.408 97.917L387.617 97.7852L396.582 194.648L501.001 116.631V115.445ZM388.936 99.2348L499.024 116.367L397.637 192.012L388.936 99.2348Z",
    fill: "url(#paint3_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.704 218.632L57.4844 208.616L131.052 133.234L114.704 218.632ZM60.2531 207.694L113.781 217.05L129.075 137.32L60.2531 207.694Z",
    fill: "url(#paint4_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 168.422L130.656 135.739L120.767 41.5117L0 166.84V168.422ZM129.337 134.816L2.10947 166.577L119.844 44.5428L129.337 134.816Z",
    fill: "url(#paint5_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 167.106V168.555L58.9334 209.014L132.106 134.027L0 167.106ZM58.8016 207.3L1.58211 168.028L127.887 136.399L58.8016 207.3Z",
    fill: "url(#paint6_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.47 136.396L119.582 42.3008L255.775 64.7044L129.47 136.396ZM121.032 43.8822L130.525 134.156L251.82 65.3634L121.032 43.8822Z",
    fill: "url(#paint7_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.263684 4.74219L0 5.26933V6.06005L119.185 43.4873L0 166.839V167.762L0.527368 168.289L120.767 43.6191L121.558 42.8284L0.263684 4.74219Z",
    fill: "url(#paint8_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.383 218.634L129.599 134.027L206.991 202.424L113.383 218.634ZM130.39 136.531L114.965 217.053L203.958 201.634L130.39 136.531Z",
    fill: "url(#paint9_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.617 99.3663L379.574 3.95312L465.14 70.6369L387.617 99.3663ZM381.156 6.85242L388.803 97.5213L462.371 70.1098L381.156 6.85242Z",
    fill: "url(#paint10_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.969 163.415L128.02 135.74L254.192 64.1797L273.969 163.415ZM131.843 134.949L272.255 161.701L253.27 66.1565L131.843 134.949Z",
    fill: "url(#paint11_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.782 164.205L252.742 63.125L305.611 113.204L272.782 164.205ZM254.852 66.9468L273.441 160.779L303.897 113.467L254.852 66.9468Z",
    fill: "url(#paint12_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.412 202.818L205.016 202.554L127.625 134.289L274.893 162.228L205.412 202.818ZM132.239 136.398L205.676 201.236L271.333 162.887L132.239 136.398Z",
    fill: "url(#paint13_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.367 114.258L380.89 3.42578L389.065 98.839L303.367 114.258ZM379.836 7.24758L306.268 112.413L387.614 97.9165L379.836 7.24758Z",
    fill: "url(#paint14_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.952 114.388L252.742 64.9681L253.665 64.5727L382.343 3.6875L304.952 114.388ZM254.983 65.2316L304.688 112.279L378.388 6.98215L254.983 65.2316Z",
    fill: "url(#paint15_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.769 194.779L303.238 112.94L388.804 97.6523L388.936 98.3113L397.769 194.779ZM306.271 113.73L396.187 191.616L387.617 99.2338L306.271 113.73Z",
    fill: "url(#paint16_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.481 194.516L272.121 162.887L272.648 162.096L304.686 112.281L305.213 112.808L399.481 194.516ZM274.231 162.096L394.471 191.88L304.95 114.258L274.231 162.096Z",
    fill: "url(#paint17_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V10.8065C2.90053 10.8065 5.40553 8.43431 5.40553 5.40323C5.40553 2.37215 3.03237 0 0 0Z",
    fill: "url(#paint18_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.776 43.0946C125.776 40.0636 123.403 37.6914 120.37 37.6914C117.338 37.6914 114.965 40.0636 114.965 43.0946C114.965 46.1257 117.338 48.4979 120.37 48.4979C123.271 48.4979 125.776 46.1257 125.776 43.0946Z",
    fill: "url(#paint19_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.401 134.157C135.401 131.126 133.028 128.754 129.995 128.754C126.963 128.754 124.59 131.126 124.59 134.157C124.59 137.188 126.963 139.56 129.995 139.56C133.028 139.429 135.401 137.056 135.401 134.157Z",
    fill: "url(#paint20_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.409 65.1025C258.409 62.0714 256.036 59.6992 253.003 59.6992C249.971 59.6992 247.598 62.0714 247.598 65.1025C247.598 68.1335 249.971 70.5057 253.003 70.5057C255.904 70.5057 258.409 68.0017 258.409 65.1025Z",
    fill: "url(#paint21_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.846 5.40323C384.846 2.37215 382.473 0 379.441 0C376.408 0 374.035 2.37215 374.035 5.40323C374.035 8.43431 376.408 10.8065 379.441 10.8065C382.473 10.8065 384.846 8.30253 384.846 5.40323Z",
    fill: "url(#paint22_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.682 98.4462C393.682 95.4151 391.309 93.043 388.277 93.043C385.244 93.043 382.871 95.4151 382.871 98.4462C382.871 101.477 385.244 103.849 388.277 103.849C391.177 103.849 393.682 101.477 393.682 98.4462Z",
    fill: "url(#paint23_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.092 70.372C469.092 67.3409 466.719 64.9688 463.687 64.9688C460.654 64.9688 458.281 67.3409 458.281 70.372C458.281 73.4031 460.654 75.7752 463.687 75.7752C466.719 75.7752 469.092 73.2713 469.092 70.372Z",
    fill: "url(#paint24_linear_197_1301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.82 118.74C307.805 118.74 310.225 116.321 310.225 113.337C310.225 110.353 307.805 107.934 304.82 107.934C301.834 107.934 299.414 110.353 299.414 113.337C299.414 116.321 301.834 118.74 304.82 118.74Z",
    fill: "url(#paint25_linear_197_1301)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_1301",
    x1: 480.588,
    y1: 141.186,
    x2: 558.397,
    y2: 86.1437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_197_1301",
    x1: 444.436,
    y1: 282.243,
    x2: 535.281,
    y2: 136.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_197_1301",
    x1: 439.049,
    y1: 127.276,
    x2: 452.331,
    y2: 59.9772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_197_1301",
    x1: 440.044,
    y1: 216.236,
    x2: 490.585,
    y2: 93.4959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_197_1301",
    x1: 91.5006,
    y1: 237.664,
    x2: 145.43,
    y2: 141.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_197_1301",
    x1: 60.4124,
    y1: 196.706,
    x2: 132.639,
    y2: 42.4402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_197_1301",
    x1: 61.0829,
    y1: 225.726,
    x2: 89.3707,
    y2: 122.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_197_1301",
    x1: 182.555,
    y1: 157.367,
    x2: 224.358,
    y2: 31.8384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_197_1301",
    x1: 56.2061,
    y1: 204.739,
    x2: 166.855,
    y2: 34.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_197_1301",
    x1: 156.665,
    y1: 237.49,
    x2: 202.578,
    y2: 132.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_197_1301",
    x1: 419.138,
    y1: 120.631,
    x2: 478.105,
    y2: 10.9217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_197_1301",
    x1: 195.503,
    y1: 185.531,
    x2: 239.027,
    y2: 52.7282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_197_1301",
    x1: 277.188,
    y1: 186.733,
    x2: 351.839,
    y2: 105.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_197_1301",
    x1: 195.718,
    y1: 218.091,
    x2: 217.407,
    y2: 121.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_197_1301",
    x1: 342.992,
    y1: 138.959,
    x2: 416.73,
    y2: 20.6719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_197_1301",
    x1: 312.667,
    y1: 139.06,
    x2: 370.422,
    y2: -1.2204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_197_1301",
    x1: 346.947,
    y1: 216.425,
    x2: 404.193,
    y2: 100.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_197_1301",
    x1: 331.009,
    y1: 212.844,
    x2: 365.59,
    y2: 101.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_197_1301",
    x1: 2.4994,
    y1: 13.2149,
    x2: 10.5015,
    y2: 4.91057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_197_1301",
    x1: 119.964,
    y1: 50.9063,
    x2: 126.226,
    y2: 37.9083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_197_1301",
    x1: 129.589,
    y1: 141.969,
    x2: 135.851,
    y2: 128.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_197_1301",
    x1: 252.596,
    y1: 72.9141,
    x2: 258.859,
    y2: 59.9162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_197_1301",
    x1: 379.034,
    y1: 13.2149,
    x2: 385.296,
    y2: 0.21694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_197_1301",
    x1: 387.87,
    y1: 106.258,
    x2: 394.132,
    y2: 93.2599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_197_1301",
    x1: 463.28,
    y1: 78.1837,
    x2: 469.543,
    y2: 65.1857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_197_1301",
    x1: 304.413,
    y1: 121.149,
    x2: 310.675,
    y2: 108.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_1301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 501,
    height: 318,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleStartLower);
export default __webpack_public_path__ + "static/media/moduleStartLower.3fefc6ff2e410bb27ae3dcda0f9cf766.svg";
export { ForwardRef as ReactComponent };